import { NgModule } from '@angular/core';
import { RouteReuseStrategy, RouterModule, Routes } from '@angular/router';

import { DefaultLayoutComponent } from './layouts/default/default.component';
import { ExtraLayoutComponent } from './layouts/extra/extra.component';

import { PageSignIn1Component } from './pages/extra-pages/sign-in-1/sign-in-1.component';
import { Page500Component } from './pages/extra-pages/page-500/page-500.component';
import { Page404Component } from './pages/extra-pages/page-404/page-404.component';
import { Page403Component } from './pages/extra-pages/page403/page403.component';
import {
    FirstTimePasswordComponent,
    ForgotPasswordComponent,
    MfaComponent,
    ResetPasswordComponent,
    SigninComponent,
    SignoutComponent
} from './pages/auth';
import { HomeComponent } from './pages/home/home.component';
import { PreviousAnalysisComponent } from './pages/previous-analysis/previous-analysis.component';
import { NewAnalysisComponent } from './pages/new-analysis/new-analysis.component';
import { SignupComponent } from './pages/auth/signup/signup.component';
import { UserComponent } from './pages/user/user.component';
import { UserPageComponent } from './user-page/user-page.component';
import { UserSignInComponent } from './pages/amplify-auth/user-sign-in/user-sign-in.component';
import { UserSignOutComponent } from './pages/amplify-auth/user-sign-out/user-sign-out.component';
import { UserNewPasswordComponent } from './pages/amplify-auth/user-new-password/user-new-password.component';
import { UserForgotPasswordComponent } from './pages/amplify-auth/user-forgot-password/user-forgot-password.component';
import { SmallMoleculeComponent } from './pages/small-molecule/small-molecule.component';
import { QpcrResultPageComponent } from './pages/qpcr-result-page/qpcr-result-page.component';
import { AuthLogComponent } from './pages/user/auth-log/auth-log.component';
import { AuthGuard } from '../app/shared/auth.guard';
import { Page401Component } from './pages/extra-pages/page401/page401.component';
import { PasswordValidityComponent } from './pages/amplify-auth/password-validity/password-validity.component';
import { DataCompilationComponent } from './pages/data-compilation/data-compilation/data-compilation.component';
import { PreviousDataSummaryComponent } from './pages/data-compilation/previous-data-summary/previous-data-summary.component';


const defaultRoutes: Routes = [
    {path: 'user-details', component: UserComponent,
    data: {
        shouldDetach: true
      }
    },
    {path: 'previous-analysis', component: PreviousAnalysisComponent,
    data: {
        shouldDetach: true
      }
    },
    {path: 'new-analysis', component: NewAnalysisComponent},
    {path: 'qpcr-molecule-analysis/:id/:user', component: QpcrResultPageComponent},
    {path: 'molecule-analysis/:id/:user', component: SmallMoleculeComponent},
    {path: 'user-info', component: UserPageComponent},
    {path:'page-401', component:Page401Component},
    {path: 'auth-log', component: AuthLogComponent},
    {path:'data-comp',component:DataCompilationComponent},
    {path:'prev-comp',component:PreviousDataSummaryComponent},
    {path: '**', component: Page404Component},
];

const extraRoutes: Routes = [
    {path: 'home',    component: HomeComponent},
    {path: 'signup',  component: SignupComponent},
    {path: 'signin',  component: UserSignInComponent},
    { path: 'new-password', component: UserNewPasswordComponent },
    {path:'password-validity',component:PasswordValidityComponent},
    {path: 'signout',  component:  UserSignOutComponent},
    {path: 'mfa', component: MfaComponent},
    {path: 'sign-in', component: PageSignIn1Component},
    {path: 'page-404', component: Page404Component},
    { path: 'page-403', component: Page403Component },
    { path: 'page-500', component: Page500Component },

    {path: 'reset-password', component: ResetPasswordComponent},
    {path: 'first-time-password', component: FirstTimePasswordComponent},
    {path: 'forgot-password', component: UserForgotPasswordComponent},

];

const routes: Routes = [
    {
        path: '',
        redirectTo: '/extra-layout/home',
        pathMatch: 'full',


    },
    {
        path: 'default-layout',
        component: DefaultLayoutComponent,
        children: defaultRoutes,
        runGuardsAndResolvers: 'always',
        canActivate: [AuthGuard],


    },
    {
        path: 'extra-layout',
        component: ExtraLayoutComponent,
        children: extraRoutes,

    },
    {
        path: '**',
        component: DefaultLayoutComponent,
        children: defaultRoutes,
        canActivate: [AuthGuard]
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {useHash: true, onSameUrlNavigation: 'reload'})],
    exports: [RouterModule],

})
export class AppRoutingModule {
}
